import type { RoomKey } from '@/api/types';
import type { SceneName } from '@/lib/illustrations';

export type { RoomKey };
export const ROOM_ORDER: RoomKey[] = ['floor', 'table', 'meal', 'calm', 'move'];

/** Tint per room (wood + v1.3 pastels; text is ink on pastels; never used for results). */
export const ROOM_STYLE: Record<RoomKey, { tag: string; scene: SceneName }> = {
  floor: { tag: 'bg-wood-100 text-wood-ink', scene: 'room-floor-play' },
  table: { tag: 'bg-lavender-200 text-ink', scene: 'room-table-time' },
  meal: { tag: 'bg-peach-200 text-ink', scene: 'room-mealtime' },
  calm: { tag: 'bg-mint-200 text-ink', scene: 'room-calm-corner' },
  move: { tag: 'bg-[#FFF1CC] text-[#6B5208]', scene: 'room-move-outdoors' },
};

export const isRoom = (v: unknown): v is RoomKey => typeof v === 'string' && (ROOM_ORDER as string[]).includes(v);
